import * as React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { MenuItem } from "components/bootstrap";
import AddEvidenceModal from "security-app/components/Investigations/plugin/shared/AddEvidenceModal";
import useActionCondition from "security-app/components/Investigations/plugin/useActionCondition";
import { useBulkAddEvidence } from "security-app/hooks/useInvestigationsAPI";
import useSelectedMessageEntities from "views/hooks/useSelectedMessageEntities";
const useUpdateInvestigation = () => {
  const { selectedEntities } = useSelectedMessageEntities();
  const { bulkAddEvidence } = useBulkAddEvidence();
  return useCallback(
    (investigationIds) => bulkAddEvidence({
      payload: {
        investigation_ids: investigationIds,
        logs: selectedEntities.map(({ id, index }) => ({ id, index }))
      }
    }),
    [bulkAddEvidence, selectedEntities]
  );
};
const MessageBulkActions = ({ modalRef }) => {
  const displayInvestigationActions = useActionCondition();
  const { t } = useTranslation("enterprise_search");
  return displayInvestigationActions && /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
    var _a;
    return (_a = modalRef()) == null ? void 0 : _a.toggle();
  }, icon: "extension" }, t("message_bulk_actions.add_to_investigation"));
};
export const MessageBulkActionsModal = React.forwardRef((_, addEvidenceModalRef) => {
  const { selectedEntities } = useSelectedMessageEntities();
  const displayInvestigationActions = useActionCondition();
  const updateInvestigation = useUpdateInvestigation();
  const onAddEvidence = async (payload) => updateInvestigation(payload.investigation_ids);
  const ids = selectedEntities.map(({ id }) => id);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, displayInvestigationActions && /* @__PURE__ */ React.createElement(AddEvidenceModal, { index: void 0, ids, type: "logs", ref: addEvidenceModalRef, onSubmit: onAddEvidence }));
});
export default MessageBulkActions;
